<template>
  <div id="app" class="layout-private">
    <nav-bar></nav-bar>
    <slot></slot>
  </div>
</template>

<script>
import NavBar from "@tt-app/components/layout/NavBar.vue";

export default {
  name: "LayoutPrivate",
  components: { NavBar }
};
</script>

<style lang="scss">
// Local SCSS variables
$layout-private-nav-bar-height: 56px;
$layout-private-nav-bar-width: 72px;

.layout-private {
  background-color: var(--color-light-background-light);
  bottom: 0;
  left: 0;
  overflow-y: auto;
  position: absolute;
  right: 0;
  top: 0;

  // Using adjacent sibling selector ensures that this style is only applied
  // to the element following #nav-bar, the root element of each view
  //
  // Views root elements are then expected to fill the remaining visible screen
  // but overflow management is up to each view
  #nav-bar + * {
    margin-top: $layout-private-nav-bar-height;
    margin-left: 0;
    width: 100%;
    height: calc(100% - #{$layout-private-nav-bar-height});
  }
}

@include responsive(tablet) {
  .layout-private {
    #nav-bar + * {
      margin-top: 0;
      margin-left: $layout-private-nav-bar-width;
      width: calc(100% - #{$layout-private-nav-bar-width});
      height: 100%;
    }
  }
}
</style>
